import styled from 'styled-components'

export const StyledNumber = styled.span`
  color: #848b95;
`
